
import Vue from 'vue'
import App from './App'
import ElementUi from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/common.css'
import '@/assets/css/wzmall.css'
import vshare from 'vshare'
import store from './store'
import '@/assets/iconfont/iconfont.css'
import router from './router/index'
import x2js from 'x2js'

import draggable from 'vuedraggable'
import 'echarts'

Vue.use(ElementUi)
Vue.use(vshare)
Vue.config.productionTip = false
// Vue.component('draggable', draggable)
Vue.prototype.$x2js = new x2js()

Vue.prototype.baseUrl = function () {
  return 'http://119.3.91.168'
}

router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title === undefined ? '【万知】万知万知，万万知，万知网里知万知；' : to.meta.title
  let token = localStorage.getItem('token')
  if (to.meta.content) {
    let head = document.getElementsByTagName('head')
    let meta = document.createElement('meta')
    document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content.keywords)
    document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content.description)
    meta.content = to.meta.content
    head[0].appendChild(meta)
  }
  if (to.meta.requireLogin) {
    if (token) {
      next()
    } else {
      next('/login')
    }
  } else {
    if (token) {
      if (to.path === '/login/login' || to.path === '/login/register') {
        next('/')
      } else {
        next()
      }
    } else {
      next()
    }
  }
})
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
  document.documentElement.scrollTop = document.body.scrollTop = 0
})

/* eslint-disable no-new */
let rootVm = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  }
})

export default rootVm



// WEBPACK FOOTER //
// ./src/main.js